import * as yup from "yup";

// O regex padrão não requer `.`, adiciona uma validação simples que requer `.`.
yup.addMethod(yup.string, "email", function validateEmail(message) {
  return this.matches(/^\S+@\S+\.\S+$/, {
    message,
    name: "email",
    excludeEmptyString: true,
  });
});

export default yup;
